// extracted by mini-css-extract-plugin
export default {"description":"HistoryDetails-description-tZwCD DescriptionListItemDescription-description-IZlGY"};